import { Type } from '@angular/core';
import { IModalData } from '@app/interfaces';

export class ModalItem<T> {
	constructor(public component: Type<any>, public data: IModalData<T>) {}
}
